import http from "../core/http";
const group = 'topupReports';

export const getInitialDataRequest = async (data) => {
    return await http.post(`${group}/getInitialData`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getTopupReportRequest = async (data) => {
    return await http.post(`${group}/getReport`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportTopupReportRequest = async (data) => {
    return await http.post(`${group}/export`, data, { responseType: 'blob' }).then(res => res.data).catch(http.defaultCatch);
}
